import { ReactNode } from 'react';
import { ToastNotificationProvider } from '@opswat/ui';
import { SWRProvider } from 'services/swr';
import { UserProvider } from 'services/User';

interface WrapRootProps {
    children: ReactNode;
}

export const WrapRoot = ({ children }: WrapRootProps) => {
    return (
        <ToastNotificationProvider>
            <UserProvider>
                <SWRProvider>
                    {children}
                </SWRProvider>
            </UserProvider>
        </ToastNotificationProvider>
    );
};
